import type { ReactNode, Ref } from "react";
import { useImperativeHandle, useRef } from "react";

import Modal from "$src/core/components/atoms/Modal";
import type { ModalRef } from "$src/core/components/atoms/Modal/types";

type Props = {
  ref?: Ref<ModalRef>;
  title?: string;
  children: ReactNode;
};

const ContentModal = ({ ref: forwardedRef, title, children }: Props) => {
  const ref = useRef<ModalRef | null>(null);

  useImperativeHandle(
    forwardedRef,
    () => ({
      present: () => ref.current?.present(),
      dismiss: () => ref.current?.dismiss(),
    }),
    [ref],
  );

  return (
    <Modal ref={ref} title={title} detents={[1]} scrollable>
      {children}
    </Modal>
  );
};

export default ContentModal;
